import axios from "axios";

export const Apimongodb = axios.create({
    baseURL: "https://apipoi.sitgps.com",
    headers: { 'Content-Type': 'application/json' },
});
Apimongodb.defaults.headers.common['Appid'] = 'sitgps';